import Vue from 'vue'
import Vant from 'vant'
import { Lazyload } from 'vant'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/styles/global.less'
import * as custom from './utils/filters'
import * as fundebug from 'fundebug-javascript'
import fundebugVue from 'fundebug-vue'
import * as utils from './utils/utils'
import env from './config/env'

// 在生产环境下, 标准打包或者打包测试环境才添加vconsole插件
if (
  process.env.NODE_ENV === 'production' &&
  (process.env.VUE_APP_TITLE == 'sit' ||
    process.env.VUE_APP_TITLE == 'uat' ||
    process.env.VUE_APP_TITLE == 'production')
) {
  const VConsole = require('vconsole')
  new VConsole()
}
Vue.use(Lazyload, {
  lazyComponent: true
})
if (process.env.NODE_ENV === 'development') {
  // 开发环境
} else {
  // 生产环境
  fundebug.apikey =
    '4cbd5094f5a23003d62b9f658bb864f3c41faa18b441e9c29f2b8059961bf1ff'
  fundebugVue(fundebug, Vue)
}

Vue.use(Lazyload, {
  lazyComponent: true
})
Vue.prototype.prefixUrl = env.ossFileUrl
Vue.prototype.utils = utils //公共方法
Vue.prototype.kfLink = 'https://work.weixin.qq.com/kfid/kfc58b8c1357915014b'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']
Vue.use(Vant)
Vue.use(VueAwesomeSwiper)
Object.keys(custom).forEach(item => Vue.filter(item, custom[item]))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
